<template>
  <div class="datepicker input-group">
    <date
      placeholder="Selecione a data"
      input-class="form-control"
      :format="format"
      :typeable="typeable"
      :language="ptBR"
      v-model="inputVal"
    >
      <span slot="afterDateInput" class="animated-placeholder"></span>
    </date>
    <span class="input-group-btn">
      <button
        class="btn btn-default btn-dateclear"
        type="button"
        @click="limpar()"
      >
        <font-awesome-icon :icon="'times'" />
      </button>
    </span>
  </div>
</template>

<script>
import date from 'vuejs-datepicker'
import { ptBR } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'datepicker',
  props: {
    value: {},
    /**
     * Se for utilizar a formatação diferente da padrão (dd MMM yyyy), não utilizar typeable=true
     * Caso ocorra, o datepicker buga e considera o primeiro campo como mês
     * Sendo assim, qualquer dia acima de 12 gera uma data null no final
     */
    format: {
      type: String,
      default: 'dd MMM yyyy'
    },
    typeable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    date
  },
  data() {
    return {
      ptBR: ptBR,
      language: 'pt-BR'
    }
  },
  methods: {
    limpar() {
      this.inputVal = null
    },
    dateSelected(date) {
      return null
    },
    formatarData(date) {
      return date.toLocaleDateString()
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped>
.btn-dateclear {
  border: 1px solid #468c36;
}
.btn-dateclear:hover {
  border: 1px solid #91ae3d;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Datepicker.vue